import { matchPath } from 'react-router-dom';

/**
 * Page-view tracking (ZD-2805) resolves a route's display name from the
 * Redux main_menu first (see routeToPageName in PrivateRoutes.tsx). Routes
 * that are gated outside the menu system entirely -- pilot features behind a
 * company allowlist, onboarding, external views -- never appear in main_menu
 * and would otherwise be tracked with no page name. Add an entry here for
 * any such route so it still gets a human-chosen name.
 *
 * `path` uses the same pattern syntax as the <Route path> in App.tsx
 * (including `:param` segments), so copy it from there verbatim.
 */
export const PAGE_NAMES: ReadonlyArray<{ path: string; name: string }> = [
  { path: '/lane-planner', name: 'Lane Planner' },
  { path: '/onboarding', name: 'Onboarding' },
  { path: '/confirmation', name: 'Onboarding confirmation' },
  { path: '/create-account', name: 'Create Account' },
  {
    path: '/dev/quickstat-booking-complete',
    name: 'Dev Quickstat Booking Complete',
  },
  { path: '/shipment/external-view/:id', name: 'Expand map' },
  { path: '/monitor', name: 'Monitor' },
  { path: '/monitor_v2', name: 'Monitor (globe)' },
  {
    path: '/airport-list/airport/airline-detail/:airlineName',
    name: 'Airline Detail',
  },
  { path: '/airport-list/airport/:code', name: 'Airport Airlines' },
  {
    path: '/airport-list/:airlineName/company-contact',
    name: 'Airline Company Contact',
  },
  { path: '/airport-list/:code/customs', name: 'Airport Customs' },
  { path: '/publish-gxp-report/:id', name: 'Publish GxP Report' },
];

/** Name for a pathname (no query string) that isn't a menu item, or
 * undefined when none of PAGE_NAMES matches. First match wins. */
export const getPageNameOverride = (pathname: string): string | undefined =>
  PAGE_NAMES.find(({ path }) => matchPath({ path, end: true }, pathname))?.name;
